module.exports = __webpack_public_path__ + "static/media/for-corporates.e9249980.svg";